import { HeaderMiniCartDropMenu } from '@/components/content/Header/parts/MiniCartDropMenu';
import { headerItemStackSX } from '@/components/content/Header/styles/itemStack';
import {
	headerMiniCartContainerSX,
	iconCountCartSX,
	numberCountCartSX,
} from '@/components/content/Header/styles/miniCart/container';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import { Stack, Tooltip, Typography } from '@mui/material';
import { FC, MouseEventHandler } from 'react';

type Props = {
	open: boolean;
	count: number;
	fromLocal: boolean;
	handleToolTip: (action: string) => () => void;
	onMouseEnter: MouseEventHandler<HTMLDivElement>;
};

export const HeaderMiniCartDesktop: FC<Props> = ({
	open,
	count,
	fromLocal,
	handleToolTip,
	onMouseEnter,
}) => (
	<Stack sx={headerMiniCartContainerSX}>
		<Tooltip
			placement="bottom"
			open={open}
			onClose={handleToolTip('close')}
			disableFocusListener
			disableHoverListener
			disableTouchListener
			PopperProps={{
				sx: {
					width: '100%',
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
					opacity: '1',
					height: '100%',
				},
			}}
			componentsProps={{
				transition: {
					sx: {
						marginRight: '20px',
						backgroundColor: 'transparent',
						color: '#2C2C2C',
						float: 'right',
					},
				} as any,
			}}
			title={
				open ? (
					<HeaderMiniCartDropMenu fromLocal={fromLocal} onClose={handleToolTip('close')} />
				) : null
			}
		>
			<Stack
				id="MiniShoppingCart"
				alignItems="center"
				onClick={onMouseEnter}
				sx={headerItemStackSX}
			>
				<Stack sx={{ alignItems: 'center', paddingTop: '0px' }}>
					{count > 0 ? (
						<Typography sx={numberCountCartSX({ isMobile: false })}>{count}</Typography>
					) : null}
					<ShoppingCartIcon sx={iconCountCartSX({ isMobile: false, isItemsCount: count > 0 })} />
				</Stack>
			</Stack>
		</Tooltip>
	</Stack>
);
